import { useMutation } from '@tanstack/vue-query';
import { ResultAsync } from 'neverthrow';
import { APIClient, getErrorMessage } from '@/api';
import contentApiClient from '@/api/contentApiClient';
import { trackSentryError } from '@/utilities/SentryHelper';
import { APIErrorCodes } from '@/enums/ErrorCodes';

export type DoubleOptinMutationVariables = {
	email: string;
	locale: string;
	captchaToken: string;
};

export const useDoubleOptInMutation = () => {
	const updateDoubleOptin = useMutation({
		mutationFn: async (variables: DoubleOptinMutationVariables) => APIClient.useWithLoader(contentApiClient.client.post('doubleoptin/subscribe', {
			headers: {
				'api-version': '1.0',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(variables),
		})),
		onError(error) {
			trackSentryError({
				errorCode: APIErrorCodes.DOUBLE_OPT_IN_FAILED,
				cause: error,
				extend: {
					transactionName: '"POST /doubleoptin/subscribe" request failed',
				},
			});
		},
	});

	const updateDoubleOptinResultAsync = (...params: Parameters<typeof updateDoubleOptin.mutateAsync>): ResultAsync<unknown, string> => ResultAsync
		.fromPromise(updateDoubleOptin.mutateAsync(...params), getErrorMessage);

	return {
		updateDoubleOptin,
		updateDoubleOptinResultAsync,
	};
};
